import ShareWindow from './ShareWindow';

export default ShareWindow;